module.exports = __webpack_public_path__ + "static/img/noticias.a68c95c5.jpg";